import toolkitApi, { toolkitSimpleTransform } from '../../toolkitApi';

import franchiseRecordsAPI from './franchiseRecordsAPI';
import { franchiseSeasonBySeasonInitialState } from './index';
import { transformFranchiseData } from './selectors';

export default toolkitApi.injectEndpoints({
    endpoints: (build) => ({
        franchises: build.query({
            query: () => ({
                url: franchiseRecordsAPI.franchiseEndpoint,
            }),
            transformResponse: transformFranchiseData,
        }),
        franchiseDetails: build.query({
            query: () => ({
                url: franchiseRecordsAPI.franchiseDetailsEndpoint,
            }),
            transformResponse: toolkitSimpleTransform,
        }),
        roster: build.query({
            query: (id) => ({
                url: franchiseRecordsAPI.rosterByTeamEndpoint(id),
            }),
            transformResponse: toolkitSimpleTransform,
        }),
        allTimeRecordVsFranchise: build.query({
            query: (id) => ({
                url: franchiseRecordsAPI.allTimeRecordVsFranchiseEndpoint(id),
            }),
            transformResponse: toolkitSimpleTransform,
        }),
        playoffFranchiseVsTeam: build.query({
            query: (id) => ({
                url: franchiseRecordsAPI.playoffFranchiseVsTeamEndpoint(id),
            }),
            transformResponse: toolkitSimpleTransform,
        }),
        franchiseSeasonBySeasonRecords: build.query({
            async queryFn(args, queryApi, extraOptions, fetchWithBQ) {
                if (!args.franchiseId) {
                    return {
                        data: franchiseSeasonBySeasonInitialState,
                    };
                }

                const [{ data: franchiseSeasonResults }, { data: franchiseDetails }] = await Promise.all([
                    fetchWithBQ(franchiseRecordsAPI.franchiseSeasonResultsEndpoint(args.franchiseId)),
                    fetchWithBQ(franchiseRecordsAPI.franchiseHistoryEndpoint(args.teamId)),
                ]);

                const modifiedSeriesTitleTeamRecords = franchiseSeasonResults.data.map((record) => {
                    //used to assist in sorting w/o giving the playoff result a ranking.
                    if (record.decision === null && record.seriesAbbrev === null && record.seriesTitle === null) {
                        return {
                            ...record,
                            seriesTitle: 'DNQ',
                            seriesAbbrev: 'DNQ',
                        };
                    } else {
                        return {
                            ...record,
                            seriesTitle:
                                record.decision === 'W' ? `Won ${record.seriesTitle}` : `${record.seriesTitle} Loss`,
                            seriesAbbrev:
                                record.decision === 'W' ? `Won ${record.seriesAbbrev}` : `${record.seriesAbbrev} Loss`,
                        };
                    }
                });

                const payloadResponse = {
                    recordsByFranchise: modifiedSeriesTitleTeamRecords,
                    franchiseDetails: franchiseDetails.data[0],
                };
                return { data: payloadResponse };
            },
        }),
    }),
});
